import React, { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

export default function SwUpdatePrompt() {
  const [waiting, setWaiting] = useState(null);

  useEffect(() => {
    if (!("serviceWorker" in navigator)) return;
    let reloading = false;
    const onControllerChange = () => {
      if (reloading) return;
      reloading = true;
      window.location.reload();
    };
    navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      if (reg.waiting) setWaiting(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const sw = reg.installing;
        if (!sw) return;
        sw.addEventListener("statechange", () => {
          if (sw.state === "installed" && navigator.serviceWorker.controller) setWaiting(sw);
        });
      });
    }).catch(() => {});
    return () => navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange);
  }, []);

  if (!waiting) return null;
  return (
    <div data-testid="sw-update-banner"
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 bg-brand-ink text-white rounded-full pl-5 pr-2 py-2 shadow-2xl border border-white/10">
      <span className="text-sm">A new version is available</span>
      <button data-testid="sw-update-reload" onClick={() => waiting.postMessage({ type: "SKIP_WAITING" })}
        className="inline-flex items-center gap-1.5 text-sm font-semibold bg-brand-terracotta hover:bg-brand-terracottaHover rounded-full px-4 py-1.5 transition-colors">
        <RefreshCw className="w-4 h-4" /> Reload
      </button>
    </div>
  );
}
